import React, { useState, useRef, useEffect } from 'react';
import Cropper from 'react-cropper';
import { Button, Grid, Typography, useMediaQuery } from '@mui/material';
import 'cropperjs/dist/cropper.css';
import { useStyles } from './style';
import { Icons, SimpleDialog, ButtonLoading, ConfirmDialog } from 'components';
import clsx from 'clsx';
import UploadMediaService from './service/services';
import { api } from 'utility';
import createToast from 'components/Toast/Toast';

const UploadCropperImage = (props) => {
    const {
        title, // عنوان بالای کراپر ها
        fullWidth, // در صورت true بودن برای نوع cover upload استفاده میشود
        icon, // آیکون بالای کراپر ها
        value, // مقدار پیش فرض جهت ویرایش 
        onChange, // تابع مربوط به تغییر آپلود
        documentFileType, // نوع فایل آپلودی
        name, // نام فایل آپلودی
        isBusinessInfo, //  فلگی است که مربوط به ویرایش کسب و کار است
        volumeFile = 6,
        acceptsList = 'png, jpg, jpeg', //  نمایش پسوند فایل قابل آپلود
    } = props;

    const [selectedImage, setSelectedImage] = useState(null); // انتخاب تصویر
    const [cropData, setCropData] = useState(null); // تصویر کراپ شده
    const [dialogOpen, setDialogOpen] = useState(false); // باز شدن  و بسنه شدن دیالوگ 
    const cropperRef = useRef(null); // رف مربوط به ماژول کراپر 
    const labelRef = useRef(null); // رف مربوط به باز شدن browser file
    const fileInputRef = useRef(null); // رف مربوط به input file
    const [isReady, setIsReady] = useState(false);  // فلگ مربوط به ئس از کراپ شدن 
    const [loadingBtn, setLoadingBtn] = useState(false); // لودینگ مربوط به دگمه ذخیره و تایید 
    const [fileHashes, setFileHashes] = useState([]); // آرایه قرار گیری hash
    const [confirmDeleteModal, setConfirmDeleteModal] = useState(false); // مدال تایید حذف تصویر
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:550px)');

    useEffect(() => {
        if (value) {
            setCropData(value);
        }
    }, [value]);

    const handleFileChange = (event) => {
        // تنظیم داده‌های فایل برای ارسال
       

        event.preventDefault();
        const file = event.target.files[0];
        const fileExtension = file.name.split('.').pop().toLowerCase();


        if (file?.size > volumeFile * 1048576) {
            createToast('خطا', `حجم فایل مورد نظر بیش از ${volumeFile} مگابایت می باشد.`, 'danger');

            return;
        }

        if (!acceptsList.includes(fileExtension)) {

            return createToast(
                'خطا',
                ` فایل ارسال شده باید در فرمت های زیر باشد.
              ${acceptsList}`,
                'danger',
            );
        }
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result.toString());
                setDialogOpen(true);
            };
            reader.readAsDataURL(file);
        }
    };

    // تابعی برای حذف فایل از سرور
    const deleteFile = async (hash) => {
        const files = {
            fileHashes: [fileHashes[0]],
            folderHashes: [],
        };

        await UploadMediaService.deleteDocService(files);
    };

    // تابع برای زدن دکمه جهت حذف تصویر

    const callDeleteBtn = (e) => {
        e.preventDefault();
        setCropData(null);
        setSelectedImage(null);
        setIsReady(false);
        setFileHashes([])
        setCropData(null)
        onChange(null);
        setConfirmDeleteModal(false)
    }

    //    تابعی برای دریافت تصویر کراپ شده و کال شدن 3 سرویس در آن
    const getCroppedImage = async () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        if (!cropperRef.current || !isReady) {
            return;
        }
        try {
            const canvas = cropperRef.current?.cropper.getCroppedCanvas();
            // تبدیل canvas به blob
            const blob = await new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.95);
            });
            if (!blob) {
                console.error('خطا در تبدیل تصویر');
                return;
            }

            // تنظیم داده‌های فایل برای ارسال
            const file = new File([blob], `${Date.now()}.jpg`, {
                type: 'image/jpeg',
                lastModified: Date.now()
            });



            // ارسال فایل به سرور
            const formData = new FormData();
            formData.append('file', file);


            const dataReq = {
                size: volumeFile * 1048576,
                type: 'IMAGE',
                'document-file-type': documentFileType, // LOGO  || BANNER
            };

            setLoadingBtn(true);
            await UploadMediaService.getHashe(dataReq)
                .then(async (res) => {
                    if (res?.result?.uploadHash?.length > 0) {
                        const podspaceBusinessUrl = process.env?.REACT_APP_BASE_URL_UPLOAD_BUSINESS_INFO_PODSAPCE;
                        const podspaceUrl = process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE;

                        await api
                            .post(`${podspaceUrl + res?.result?.uploadHash}`, formData)
                            .then(async (result) => {
                                let data = result?.data?.result;
                                if (isBusinessInfo) {
                                    await UploadMediaService.getDownloadableHash(data?.hash).then((res) => {
                                        onChange(`${podspaceBusinessUrl}${res?.result}`);
                                        setLoadingBtn(false);
                                        createToast('موفق', 'بارگذاری تصویر با موفقیت انجام شد.', 'success');
                                    })
                                } else {

                                    onChange(`${podspaceUrl + data?.hash}`);
                                    setLoadingBtn(false);
                                    createToast('موفق', 'بارگذاری تصویر با موفقیت انجام شد.', 'success');
                                }


                                setTimeout(() => {

                                    if (!fileHashes) {
                                        setFileHashes([data.hash]);
                                    } else {
                                        setFileHashes((old) => [...old, data.hash]);
                                    }
                                }, 1000);


                                if (fileHashes?.length === 1) {
                                    deleteFile();
                                    setFileHashes(fileHashes.slice(1, 2));
                                }
                                const url = URL.createObjectURL(blob);
                                setCropData(url);
                            })
                            .catch((error) => {
                                setLoadingBtn(false);
                                if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                }
                            });
                    }
                })
                .catch((error) => {
                    setLoadingBtn(false);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                });

            setDialogOpen(false);

        } catch (error) {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            console.error('خطا در ذخیره تصویر برش‌خورده:', error);
        }
    };
    // تابعی برای آماده شدن کراپر
    const handleCropReady = () => {
        setIsReady(true);
    };

    // تابعی برای چرخاندن تصویر
    const handleRotate = () => {
        if (!cropperRef.current || !isReady) return;

        // اضافه کردن transition به element
        const element = cropperRef.current.cropper.container;
        element.style.transition = 'transform 0.5s ease-in-out';

        // انجام rotate
        cropperRef.current.cropper.rotate(90);

        // حذف transition بعد از انیمیشن
        setTimeout(() => {
            element.style.transition = '';
        }, 500);

    };

    // تابعی برای معکوس کردن تصویر افقی
    const handleFlipHorizontal = () => {
        if (!cropperRef.current || !isReady) return;
        const imageData = cropperRef.current?.cropper.getData();
        cropperRef.current?.cropper.scaleY(-imageData.scaleY);
    };

    // تابعی برای معکوس کردن تصویر عمودی
    const handleFlipVertical = () => {
        if (!cropperRef.current || !isReady) return;
        const imageData = cropperRef.current?.cropper.getData();
        cropperRef.current?.cropper.scaleX(-imageData.scaleX);
    };

    // تابعی برای بزرگنمایی و کوچکنمایی تصویر
    const handleZoom = (type) => {
        if (!cropperRef.current || !isReady) return;

        const element = cropperRef.current.cropper.container;
        element.style.transition = 'transform 0.3s ease-in-out';

        if (type === 'in') {
            cropperRef.current.cropper.zoom(0.1);
        } else {
            cropperRef.current.cropper.zoom(-0.1);
        }

        setTimeout(() => {
            element.style.transition = '';
        }, 300);
    };

    // تابعی برای بستن دیالوگ
    const handleClose = () => {
        setDialogOpen(false);
        setIsReady(false);
        setTimeout(() => {
            setSelectedImage(null);
        }, 1000)
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div dir="rtl">
            <div className={classes.actions}>
                <h4>{title || 'بارگذاری تصویر'}</h4>
                <>
                    <input
                        hidden
                        accept=".png, .jpeg, .jpg"
                        type="file"
                        id={`upload - ${name} `}
                        onChange={handleFileChange}
                        ref={fileInputRef}
                    />
                    <label htmlFor={`upload - ${name} `} className={clsx(classes.actionButtons, fullWidth ? 'fullWidth' : '')} ref={labelRef}>

                        {!cropData ? (
                            <Grid
                                className={classes.placeholder}
                                alignItems="center"
                                direction="column"
                                justifyContent="center"
                                container
                                item
                            >
                                <div className={classes.uploadIcon}>
                                    <Icons icon={icon || 'image'} color="#667585" hover="#667585" size="28" />
                                </div>
                                <Typography className={classes.dragHereText} variant="h5" align="center">
                                    <p className={classes.dragHereTextDesc}>
                                        {' '}
                                        <b className={classes.dragHereTextBold}>
                                            انتخاب تصویر
                                        </b>
                                        {' '}
                                        کلیک کنید
                                    </p>
                                </Typography>
                                <Typography className={classes.showFormat} variant="h5" align="center">
                                    (حداکثر {volumeFile} مگابایت) png, jpg, jpeg
                                </Typography>
                            </Grid>
                        ) : (
                            <div className={classes.uploadBlock}>
                                <img
                                    src={cropData}
                                    alt={title}
                                    style={{ maxWidth: '100%' }}
                                />
                                <div className={classes.btnActiopnModify}>
                                    <ButtonLoading
                                        variant="contained"
                                        className={classes.changeButton}
                                        name={
                                            <>
                                                <Icons icon="ChangePicture" color="#4050AC" size="22" />
                                                تغییر تصویر
                                            </>
                                        }

                                        onClick={(e) => {
                                            if (labelRef.current) {
                                                labelRef.current.click();
                                            }

                                        }}
                                    />


                                    <ButtonLoading
                                        variant="contained"
                                        className={classes.removeButton}
                                        name={
                                            <>
                                                <Icons icon="TrashPicture" color="#F44336" size="22" />
                                                حذف تصویر
                                            </>
                                        }
                                        onClick={(e) => {
                                            setConfirmDeleteModal(true)

                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </label>
                </>
            </div>

            <SimpleDialog
                title="برش تصویر"
                open={dialogOpen}
                maxWidth="sm"
                icon={<Icons icon="image" color="#2B3990" size="22" />}
                actions={
                    <>
                        <ButtonLoading
                            onClick={getCroppedImage}
                            variant="contained"
                            color="primary"
                            name="تایید و ذخیره"
                            loading={loadingBtn}
                        />
                        <ButtonLoading
                            onClick={handleClose}
                            variant="contained"
                            name="انصراف"
                            disabled={loadingBtn}
                        />
                    </>
                }
            >
                <Grid>
                    {selectedImage && (
                        <>
                            <Grid className={classes.blockCropper}>
                                <Cropper
                                    ref={cropperRef}
                                    src={selectedImage}
                                    style={{ height: matches ? '300px' : '350px', width: '100%' }}
                                    aspectRatio={name === 'logo' ? 1 : 16 / 9}
                                    guides={true}
                                    cropBoxResizable={true}
                                    cropBoxMovable={true}
                                    zoomTo={0.5}
                                    viewMode={1}
                                    background={false}
                                    ready={handleCropReady}
                                    circularCrop={true}
                                    onError={(error) => {
                                        console.error('خطای کراپر:', error);
                                        setIsReady(false);
                                    }}
                                />
                                <div className={classes.controller}>
                                    <Button
                                        onClick={handleRotate}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Icons icon="Refresh" color="#2B3990" size="18" />}
                                        disabled={!isReady || loadingBtn}
                                        title="چرخاندن تصویر"
                                        className={classes.btnActiopn}
                                    />
                                    <Button
                                        onClick={handleFlipHorizontal}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Icons icon="FlipHorizental" color="#2B3990" size="18" />}
                                        disabled={!isReady || loadingBtn}
                                        title="معکوس کردن افقی"
                                        className={classes.btnActiopn}
                                    />
                                    <Button
                                        onClick={handleFlipVertical}
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<Icons icon="FlipVertical" color="#2B3990" size="18" />}
                                        disabled={!isReady || loadingBtn}
                                        title="معکوس کردن عمودی"
                                        className={classes.btnActiopn}
                                        size="small"
                                    />
                                    <Button
                                        onClick={() => handleZoom('in')}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Icons icon="zoomIn" color="#2B3990" size="18" />}
                                        disabled={!isReady || loadingBtn}
                                        title="بزرگنمایی"
                                        className={classes.btnActiopn}
                                    />
                                    <Button
                                        onClick={() => handleZoom('out')}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Icons icon="zoomOut" color="#2B3990" size="18" />}
                                        disabled={!isReady || loadingBtn}
                                        title="کوچکنمایی"
                                        className={classes.btnActiopn}
                                    />
                                </div>
                            </Grid>
                        </>
                    )}
                </Grid>
            </SimpleDialog>
            <ConfirmDialog
                open={confirmDeleteModal}
                onClose={() => setConfirmDeleteModal(false)}
                onConfirm={(e) => callDeleteBtn(e)}
                title="تایید حذف تصویر"
                content="آیا از حذف تصویر انتخاب شده اطمینان دارید؟"
                confirmButtonText="حذف تصویر"
                cancelButtonProps="انصراف"
            />
        </div>
    );
};

export default UploadCropperImage;